const calendar = document.querySelector("#calendar_main"),
  input = document.querySelector("#date"),
  calHeader = document.querySelector("#calendar_header"),
  calHeaderTitle = document.querySelector("#calendar_header span"),
  calDays = document.querySelector("#cal_days"),
  days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

let oneDay = 60 * 60 * 24 * 1000;
let todayTimestamp =
  Date.now() -
  (Date.now() % oneDay) +
  new Date().getTimezoneOffset() * 1000 * 60;

let selectedDay = null;


// Get num of days in month
// month param 0-11
const getNumberOfDays = (year, month) => {
  return 40 - new Date(year, month, 40).getDate();
};

// Calc day details
const getDayDetails = (args) => {
  let date = args.index - args.firstDay;
  let day = args.index % 7;
  let prevMonth = args.month - 1;
  let prevYear = args.year;
  if (prevMonth < 0) {
    prevMonth = 11;
    prevYear--;
  }
  let prevMonthNumberOfDays = getNumberOfDays(prevYear, prevMonth);

  let _date =
    (date < 0 ? prevMonthNumberOfDays + date : date % args.numberOfDays) + 1;
  let month = date < 0 ? -1 : date >= args.numberOfDays ? 1 : 0;
  let timestamp = new Date(args.year, args.month, _date).getTime();
  return {
    date: _date,
    day,
    month,
    timestamp,
    dayString: days[day]
  };
};

// [{}] each {} with details for each day of month
// const getMonthDetails = (year, month) => {
//   let firstDay = new Date(year, month).getDay();
//   let numberOfDays = getNumberOfDays(year, month);
//   let monthArray = [];
//   let rows = 5;
//   let currentDay = null;
//   let index = 0;
//   let cols = 7;

//   for (let row = 0; row < rows; row++) {
//     for (let col = 0; col < cols; col++) {
//       currentDay = getDayDetails({
//         index,
//         numberOfDays,
//         firstDay,
//         year,
//         month
//       });
//       monthArray.push(currentDay);
//       index++;
//     }
//   }
//   return monthArray;
// };

const getMonthDetails = (year, month) => {
    let firstDay = new Date(year, month).getDay();
    let numberOfDays = getNumberOfDays(year, month);
    let monthArray = [];
    let rows = Math.ceil((numberOfDays + firstDay) / 7); // calculate the required number of rows
    let currentDay = null;
    let index = 0;
    let cols = 7;
  
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        currentDay = getDayDetails({
          index,
          numberOfDays,
          firstDay,
          year,
          month
        });
        monthArray.push(currentDay);
        index++;
      }
    }
    return monthArray;
  };
  

// Variables that get updated with "state" changes
let date = new Date();
let year = date.getFullYear();
let month = date.getMonth();
let monthDetails = getMonthDetails(year, month);

const isCurrentDay = (day, cell) => {
  if (day.timestamp === todayTimestamp) {
    cell.classList.add("isCurrent");
  }
};

// Checks if day is one selected
const isSelectedDay = (day, cell) => {
  if (selectedDay && day.timestamp === selectedDay && cell.classList.contains("current")) {
    // console.log("selectedDay", selectedDay, day.timestamp, 'cell', cell);
    cell.classList.add("active");
    cell.classList.add("isSelected");
  }
};

// Get month str
const getMonthStr = (month) =>
  months[Math.max(Math.min(11, month), 0)] || "Month";

// Set year using arrows
const setHeaderNav = (offset) => {
  month = month + offset;
  if (month === -1) {
    month = 11;
    year--;
  } else if (month === 12) {
    month = 0;
    year++;
  }
  monthDetails = getMonthDetails(year, month);
  return {
    year,
    month,
    monthDetails
  };
};

const generateYearOptions = (startYear, endYear, selectedYear) => {
    let options = '';
    for (let i = startYear; i <= endYear; i++) {
      options += `<option value="${i}" ${i === selectedYear ? 'selected' : ''}>${i}</option>`;
    }
    return options;
  };

// Set dynamic calendar header
const setHeader = (year, month) => {
    const currentYear = new Date().getFullYear();
  const yearOptions = generateYearOptions(1900, currentYear, year);
  const yearSelect = `<select id="yearSelect">${yearOptions}</select>`;

  calHeaderTitle.innerHTML = getMonthStr(month) + " " + yearSelect;

  document.querySelector('#yearSelect').addEventListener('change', (e) => {
    year = parseInt(e.target.value);
    // console.log("yearSelect", e.target.value, year);
    monthDetails = getMonthDetails(year, month);
    setHeader(year, month);
    calendar.innerHTML = '';
    setCalBody(monthDetails);
    updateInput();
    updateFrontButtonState(year, month);
  });
};

// Set calendar header
setHeader(year, month);

// Add function to update front button state
const updateFrontButtonState = (currentYear, currentMonth) => {
  const frontButton = document.querySelector('.cal-btn.front');
  const today = new Date();
  const todayMonth = today.getMonth();
  const todayYear = today.getFullYear();
  
  // console.log("updateFrontButtonState", currentMonth, currentYear, todayMonth, todayYear);
  
  if (currentMonth === todayMonth && currentYear === todayYear) {
    frontButton.classList.add('disabled');
    frontButton.style.opacity = '0.5';
  } else {
    frontButton.classList.remove('disabled');
    frontButton.style.opacity = '1';
    frontButton.style.cursor = 'pointer';
  }
};

// Call the function initially
updateFrontButtonState(year, month);

// 1677139200000 => "2023-02-23"
const getDateStringFromTimestamp = (timestamp) => {
  let dateObject = new Date(timestamp);
  let month = dateObject.getMonth();
  let date = dateObject.getDate();
  return `${getMonthStr(month)} ${date}, ${dateObject.getFullYear()}`;
};

const setDateToInput = (timestamp) => {
  let dateString = getDateStringFromTimestamp(timestamp);
  input.value = dateString;
};

// Add days row to calendar
for (let i = 0; i < days.length; i++) {
  let div = document.createElement("div"),
    span = document.createElement("span");

  div.classList.add("cell_wrapper");
  span.classList.add("cell_item");

  span.innerText = days[i].slice(0, 2);

  div.appendChild(span);
  calDays.appendChild(div);
}

// Add dates to calendar
const setCalBody = (monthDetails) => {
  for (let i = 0; i < monthDetails.length; i++) {
    let div = document.createElement("div"),
      span = document.createElement("span");

    div.classList.add("cell_wrapper");
    div.classList.add("cal_date");
    monthDetails[i].month === 0 && div.classList.add("current");
    monthDetails[i].month === 0 && isCurrentDay(monthDetails[i], div);
    isSelectedDay(monthDetails[i], div);
    span.classList.add("cell_item");

    span.innerText = monthDetails[i].date;

    // Disable dates later than today
    if (monthDetails[i].timestamp > todayTimestamp) {
      div.classList.add("disabled");
    }

    div.appendChild(span);
    calendar.appendChild(div);

    if (monthDetails[i].timestamp > todayTimestamp) {
        div.classList.add("disabled");
        div.style.pointerEvents = "none";
        div.style.opacity = "0.5";
    }
  }
};

setCalBody(monthDetails);

const updateCalendar = (btn) => {
  let newCal, offset;
  
  // Get current year from select first
  const selectedYear = parseInt(document.querySelector('#yearSelect').value);
  year = selectedYear; // Update global year variable

  if (btn.classList.contains("back")) {
    offset = -1;
  } else if (btn.classList.contains("front")) {
    // Prevent navigating to future months
    if (month === new Date().getMonth() && year === new Date().getFullYear()) {
      return;
    }
    offset = 1;
  }

  newCal = setHeaderNav(offset);
  month = newCal.month; // Update global month variable
  year = newCal.year; // Update global year variable
  setHeader(year, month);
  calendar.innerHTML = "";
  setCalBody(newCal.monthDetails);
  updateInput(); // Re-apply event listeners after updating calendar
  
  // Update front button state after calendar update
  updateFrontButtonState(year, month);
};

// Only one calendar date is selected
const selectOnClick = () => {
  document.querySelectorAll(".cell_wrapper").forEach((cell) => {
    cell.classList.contains("isSelected") && cell.classList.remove("active");

    if(cell.classList.contains("isCurrent") &&
      !cell.classList.contains("active")) {
      cell.querySelector("span").classList.add("inactive_indicator");
    }
  });

  document.querySelector('#date_picker_calendar').classList.add('hidden');
  document.querySelector('#date_picker_input').classList.remove('showCal');
};

const updateInput = () => {
  let currentDay = document.querySelector(".isCurrent");

  document.querySelectorAll(".cell_wrapper").forEach((cell) => {
    if (cell.classList.contains("current")) {
      cell.addEventListener("click", (e) => {
        let cell_date = e.target.textContent;

        currentDay !== null && currentDay.classList.remove("active");

        for (let i = 0; i < monthDetails.length; i++) {
          if (monthDetails[i].month === 0) {
            if (monthDetails[i].date.toString() === cell_date) {
              selectedDay = monthDetails[i].timestamp;
              setDateToInput(selectedDay);
              selectOnClick();

              isSelectedDay(monthDetails[i], cell);

              cell.querySelector('span').classList.contains('inactive_indicator') 
              && cell.querySelector('span').classList.remove('inactive_indicator');

              // Remove error class from birthday input when date is selected
              input.classList.remove('error');
            }
          }
        }
      });
    }
  });
};

updateInput();

// Set header nav actions
document.querySelectorAll(".cal-btn").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    updateCalendar(btn);
  });
});

const toggleCalendar = () => {
  document.querySelector('#date_picker_calendar').classList.toggle('hidden');
  document.querySelector('#date_picker_input').classList.toggle('showCal');
  const dateInput = document.querySelector('#date')
  dateInput.classList.toggle('onFocus');

//     //   get date in required format
//   console.log(dateInput.value.replace(',', ''));
}

input.addEventListener('click', toggleCalendar);
document.querySelector('.toggle-calendar').addEventListener('click', toggleCalendar);
